import BaseAPI from "../base";

// 数据中心
class BugReportService extends BaseAPI {
  // 获取错误报告信息
  getBugReport(params) {
    return this.post({
      url: "/YuanHe/BugReport/Get",
      params,
    });
  }
}

export default new BugReportService();
